import "./AboutPetsWhirl.module.css";
import Header from "@/reusable_sections/Header";
import Story from "./sections/Story";
import EditorialProcess from "./sections/EditorialProcess";
import MedicalReview from "./sections/MedicalReview";
import Experts from "./sections/Experts";
import Disclosures from "./sections/Disclosures";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function AboutPetsWhirlPage() {
  return <div>
      <Header />
      <Story />
      <EditorialProcess />
      <MedicalReview />
      <Experts />
      <Disclosures />
      <Contact />
      <Footer />
    </div>;
}